import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Grid,
  Typography,
  Button,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

import useStyles from './styles';

function Header({
  className,
  ...rest
}) {
  const classes = useStyles();

  return (
    <Grid
      className={clsx(classes.rootHeader, className)}
      container
      justifyContent="space-between"
      alignItems="center"
      style={{ marginBottom: '14px' }}
      {...rest}
    >
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography
          variant="h1"
          color="textPrimary"
          style={{ fontSize: '28px' }}
        >
          Editar Reporte
        </Typography>
        <Button
          component={RouterLink}
          to="/administracion/reportes"
          variant="contained"
          color="primary"
        >
          Volver
        </Button>
      </Grid>
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
};

export default Header;
